export default {
    get(element, variable) {
        if (typeof element.lang === 'undefined' || typeof element.lang[variable] === 'undefined') {
            return 'Die Sprachvariable "' + variable + '" ist nicht definiert. '
        }
        else {
            return element.lang[variable]
        }
    }
}
